module.exports = __webpack_public_path__ + "img/support_f2.26d8b028.png";